import React, { Component } from "react";
import client from "@culturehq/client";
import { Button, Loader, Pagination, Table, Warning } from "@culturehq/components";

import { t, Trans } from "app/utils";

import PageHeader from "components/display/PageHeader";

import { createEntity, updateEntity, deleteEntity } from "./mutations";
import OrganizationValueModal from "./values/OrganizationValueModal";
import OrganizationValueRow from "./values/OrganizationValueRow";

const createOrganizationValue = createEntity("organizationValues");
const updateOrganizationValue = updateEntity("organizationValues");
const deleteOrganizationValue = deleteEntity("organizationValues");

class OrganizationValues extends Component {
  state = { loading: true, organizationValues: [] };

  componentDidMount() {
    const { match } = this.props;

    this.fetchOrganizationValues(match.params.page || 1);
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;

    if (match.params.page !== prevProps.match.params.page) {
      this.fetchOrganizationValues(match.params.page || 1);
    }
  }

  handlePageClick = page => {
    const { history } = this.props;

    history.push(`/admin/values/${page}`);
  };

  handleCreate = organizationValue => {
    this.setState(createOrganizationValue(organizationValue));
  };

  handleUpdate = organizationValue => {
    this.setState(updateOrganizationValue(organizationValue));
  };

  handleDelete = organizationValue => {
    this.setState(deleteOrganizationValue(organizationValue));
  };

  async fetchOrganizationValues(page) {
    this.setState({ loading: true });

    const { organizationValues, pagination } = await client.listOrganizationValues({ page });

    this.setState({ loading: false, organizationValues, pagination });
  }

  render() {
    const { organizationValues, loading, pagination } = this.state;

    return (
      <div className="padding-left-15px padding-right-15px">
        <PageHeader title={t("Manage Organization Values")}>
          <Trans>
            Manage the list of your organization&#39;s core values. Events and
            recognitions can be associated with one or more of your
            organization&#39;s values. Emphasize your organization&#39;s values
            by incorporating them into the platform.
          </Trans>
        </PageHeader>

        <OrganizationValueModal onCreate={this.handleCreate}>
          {onTrigger => (
            <Button icon="plus" primary onClick={onTrigger}>
              <Trans>Add a Value</Trans>
            </Button>
          )}
        </OrganizationValueModal>

        <Loader loading={loading}>
          <Table>
            <thead>
              <tr>
                <th>Organization Value Name</th>
                <th>Created</th>
                <th>Updated</th>
                <th className="actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              {organizationValues.map(organizationValue => (
                <OrganizationValueRow
                  key={organizationValue.id}
                  organizationValue={organizationValue}
                  onUpdate={this.handleUpdate}
                  onDelete={this.handleDelete}
                />
              ))}
            </tbody>
          </Table>

          {organizationValues.length < 1 && (
            <Warning>
              <strong>Uh oh!</strong> No results to show.
            </Warning>
          )}

          <Pagination {...pagination} onClick={this.handlePageClick} />
        </Loader>
      </div>
    );
  }
}

export default OrganizationValues;
